import React from 'react';
import SelectWithFilter from './SelectWithFilter';
import AddressService from '../../../../Services/AddressService';
import AddressBox from '../AddressBox';
import ErrorMessage from '../../../ErrorMessage';

export default class AddressWithInformationByEntityTypeSelect extends React.Component {
  static defaultProps = {
    EntityTypeId: -1,
    EntityId: -1,
    fieldName: 'defaultFieldname',
    showSelectFilterAt: 10,
    filterCleared: false,
    value: null,
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    AddressService.GetAddressListByEntityAndEntityId(this.props.EntityId, this.props.EntityTypeId)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.data.forEach((addressResource) => {
          optValues.push({
            label: `${addressResource.name} (${addressResource.addressId})`,
            value: addressResource.addressId,
            disabled: false,
          });
        });
        this.setState({ itemList: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('SAWIBET44');
      });
  }

  renderSelectField() {
    return (
      <SelectWithFilter
        value={this.props.value}
        onChange={(e) => {
          this.props.onChange(e.value);
        }}
        className='col-12'
        showSelectFilterAt={this.props.showSelectFilterAt}
        selectValues={this.state.itemList}
        filterCleared={this.props.filterCleared}
        fieldName={this.props.fieldName}
      />
    );
  }

  render() {
    if (this.props.value === '') return <div className='w-100'>{this.renderSelectField()}</div>;

    return (
      <div className='w-100'>
        {this.renderSelectField()}
        <br />
        <AddressBox
          className=' col-12'
          addressId={this.props.value}
          UpdateRecord={() => this.populateListData()}
        />
      </div>
    );
  }
}
